module.exports = __webpack_public_path__ + "img/IMG_0505.47fcfda1.jpg";